import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import syncPreview from '../higher-order/SyncPreview';
import CustomPythonButtons from '../CustomPythonButtons';

const IndexFinger = ({
  customPythons,
  insideCurrentCustomPython,
  onInsideCustomPythonClick,
  outsideCurrentCustomPython,
  onOutsideCustomPythonClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <CustomPythonButtons
      title="INDEX FINGER INSIDE COLOR"
      className="finger-inside-color-wrap"
      images={customPythons}
      currentCustomImage={insideCurrentCustomPython}
      onClick={onInsideCustomPythonClick}
    />
    <CustomPythonButtons
      title="INDEX FINGER OUTSIDE COLOR"
      className="finger-outside-color-wrap"
      images={customPythons}
      currentCustomImage={outsideCurrentCustomPython}
      onClick={onOutsideCustomPythonClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { indexInsidePython, indexOutsidePython } = state.glove;

  return {
    customPythons: state.builder.leatherColors[state.glove.leatherGrade.id],
    insideCurrentCustomPython: indexInsidePython,
    outsideCurrentCustomPython: indexOutsidePython,
  };
};

const mapDispatchToProps = dispatch => ({
  onInsideCustomPythonClick: python => dispatch(updateGlove({ indexInsidePython: python })),
  onOutsideCustomPythonClick: python => dispatch(updateGlove({ indexOutsidePython: python })),
});

export default syncPreview(connect(
  mapStateToProps,
  mapDispatchToProps,
)(IndexFinger), 'fingerSide');
